import { useEffect } from "react";

import {
  Button,
  Icon_AddComment24,
  isLoggedIn,
  Modal,
  useManagedModal,
} from "@shapr3d/frontend-lib";

import { useKeyboardHandle } from "../../hooks/useKeyboardHandle";
import { useMouseHandle } from "../../hooks/useMouseHandle";
import useTranslation from "../../hooks/useTranslation";
import { useCommentsStore } from "../../stores/commentStore";
import { navigateToAuth } from "../../utils/authUtils";
import { ToolButton } from "../ToolButton/ToolButton";

import style from "./Toolbar.module.css";

interface ToolbarProps {
  isDisabled?: boolean;
}

export const Toolbar = ({ isDisabled }: ToolbarProps) => {
  const { isInAddCommentMode, toggleIsInAddCommentMode } = useCommentsStore();
  const { t, m } = useTranslation();
  useKeyboardHandle();
  useMouseHandle();
  const loginModal = useManagedModal();

  useEffect(() => {
    if (isInAddCommentMode && !isLoggedIn()) {
      loginModal.open();
      toggleIsInAddCommentMode({ source: "tool_menu" });
    }
  }, [isInAddCommentMode, loginModal, toggleIsInAddCommentMode]);

  const handleAddComment = () => {
    if (!isLoggedIn()) {
      loginModal.open();
    } else {
      toggleIsInAddCommentMode({ source: "tool_menu" });
    }
  };

  return (
    <div className={style.wrapper}>
      <ToolButton
        title={t(m.ModelViewer.AddCommentTitle)}
        alt={t(m.ModelViewer.AddCommentAlt)}
        icon={<Icon_AddComment24 />}
        onClick={() => handleAddComment()}
        shouldShowLabel
        isActive={isInAddCommentMode}
        label={t(m.ModelViewer.AddCommentLabel)}
        activeLabel={t(m.ModelViewer.PlaceCommentLabel)}
        isDisabled={isDisabled}
      />

      <Modal {...loginModal.props} size="small" title={t(m.ModelViewer.LoginModalTitle)}>
        <div className={style.modalContainer}>
          <div className={style.modalText}>{t(m.ModelViewer.LoginModalText)}</div>
          <Button variant="primary" onClick={() => navigateToAuth()} className={style.button}>
            {t(m.ModelViewer.LoginButton)}
          </Button>
        </div>
      </Modal>
    </div>
  );
};
